export const enum NetsuiteLogSyncStatus {
  CRITICAL = 'Critical',
  ERROR = 'Error',
  WARNING = 'Warning',
  INFO = 'Info',
  DEBUG = 'Debug',
  NOTSET = 'Notset',
}
